import { IItemComDNA, IItemDNA } from '../interfaces/item-dna.interface';
import { IPLM } from '../interfaces/plm.interface';

export const PARAMETROS_HERDAVEIS: {
  campo: keyof IPLM;
  campoDna: keyof IItemDNA;
  rotulo: string;
}[] = [
  { campo: 'tipoEstrategicoPLM', campoDna: 'tipoEstrategico', rotulo: 'Tipo Estratégico' },
  { campo: 'taxaAdocaoPLM', campoDna: 'taxaAdocao', rotulo: 'Taxa de Adoção' },
  {
    campo: 'pesoMedioMaturacaoPLM',
    campoDna: 'pesoMedioMaturacao',
    rotulo: 'Peso Médio de Maturação',
  },
  {
    campo: 'taxaMaturacaoNascimentoPLM',
    campoDna: 'taxaMaturacaoNascimento',
    rotulo: 'Curva de Maturação',
  },
  {
    campo: 'taxaMaturacaoCrescimentoPLM',
    campoDna: 'taxaMaturacaoCrescimento',
    rotulo: 'Curva de Maturação',
  },
  {
    campo: 'taxaMaturacaoFortalecimentoPLM',
    campoDna: 'taxaMaturacaoFortalecimento',
    rotulo: 'Curva de Maturação',
  },
  {
    campo: 'taxaMaturacaoMaturidadePLM',
    campoDna: 'taxaMaturacaoMaturidade',
    rotulo: 'Curva de Maturação',
  },
];

export const separarDnaDoItem = <T>(
  lido: T & IItemComDNA
): { entidade: T; dna: IItemDNA | null } => {
  const { dnaPLM, ...entidade } = lido;
  return { entidade: entidade as T, dna: dnaPLM ?? null };
};

export const estaPreenchido = (valor: unknown): boolean =>
  valor !== null && valor !== undefined && valor !== '';

export const listarParametrosMutados = (
  valores: Partial<IPLM> | null,
  dna: IItemDNA | null = null
): string[] => {
  if (!valores) {
    return [];
  }

  const rotulos = PARAMETROS_HERDAVEIS.filter(
    ({ campo, campoDna }) =>
      estaPreenchido(valores[campo]) && (!dna || valores[campo] !== dna[campoDna])
  ).map(({ rotulo }) => rotulo);

  if (valores.publicosAlvo?.length) {
    rotulos.unshift('Públicos-Alvo');
  }

  return Array.from(new Set(rotulos));
};
